<template>
  <div>
    <div class="seccion-02">
        <!--<img :src="ImagenTmp" class="d-block" alt="...">-->
    </div>
  </div>
</template>

<script>
export default {
    name:'',
    props:["pseccion"],
    components:{},
    data() {
        return {
            ImagenTmp:"../assets/style/images/demo.jpg",
        }
    },methods: {
        get_portada(){
            this.$http.get(
                'portada/recoveryOne',
                {
                    params:{Seccion: this.pseccion}
                }
            ).then( (res) => {
                if(res.data.data)
                {
                    this.portada = res.data.data.portada;
                    this.ImagenTmp = res.data.RutaFile+this.portada.Imagen;
                }  
            });
        }
    },mounted() {
        //this.get_portada();
    },
}
</script>